// extracted by mini-css-extract-plugin
export default {"wrapperbtn":"bp_bq","wrapperbtn_lobby":"bp_br","wrapperbtn__inner":"bp_bs","closeBtn":"bp_bt"};